import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Option } from 'src/app/model/common/option';
@Injectable()
export class TipologiaItinereService {
  constructor(private http: HttpClient) {}

  getTipologiaItinere() {
    return this.http.get<Option[]>('/assets/mocks/tipologia-itinere.json');
  }
}
